import React, { useRef, useState } from "react";
import dxLogo from "../../icons/dx_connect_logo.svg";
import { Auth } from "aws-amplify";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import {
  Copyright,
  DropItem,
  Dropdown,
  Hamburger,
  Line,
  LogoWrapper,
  SignOut,
  Wrapper,
} from "./MobileNavStyles";

const MobileNav = ({ navItems }) => {
  const [dropdown, setDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useOutsideClick(dropdownRef, () => setDropdown(false));

  async function handleSignout() {
    try {
      await Auth.signOut();
    } catch (err) {
      console.error("Error signing out user", err);
    }
  }

  return (
    <>
      <Wrapper>
        <LogoWrapper>
          <img height={40} src={dxLogo} alt="Dream Ex Connect" />
        </LogoWrapper>
        <Hamburger ref={dropdownRef} onClick={() => setDropdown(!dropdown)}>
          <Line />
          <Line />
          <Line />
          {dropdown && (
            <Dropdown>
              {navItems.map((item) => (
                <DropItem
                  key={`link_${item.title}`}
                  to={item.link}
                  exact={item.exact ? 1 : 0}
                >
                  {item.title}
                </DropItem>
              ))}
              <SignOut onClick={handleSignout}>SIGN OUT</SignOut>
              <Copyright>&copy; 2019,2020 Dream Exchange LLC</Copyright>
            </Dropdown>
          )}
        </Hamburger>
      </Wrapper>
    </>
  );
};

export default MobileNav;
